import { CircularProgress } from '@mui/material'
import { HeroWrapper, OurResultsWrapper } from '../styled'

const LoadingState = () => {
  return (
    <OurResultsWrapper>
      <HeroWrapper sx={{ height: '80vh', justifyContent: 'center' }}>
        <CircularProgress />
      </HeroWrapper>
    </OurResultsWrapper>
  )
}

export default LoadingState
